<template>
  <div>
    <nav-title :color="false" :title="'Home Challenge'" />
    <div v-html="getCriterionDescription" class="py-3 container px-lg-5 full-size-img"></div>
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import store from "@/store";
import { mapGetters } from "vuex";

export default {
  components: {
    navTitle
  },
  computed: {
    ...mapGetters("general", ["getCriterionDescription"])
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch("general/fetchCriterionDescription")]).then(
      () => {
        next();
      }
    );
  }
};
</script>
<style lang="scss">
.full-size-img img {
  width: 100% !important;
}
</style>